import { Box, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { t } from '../../constants/translations';
import { useLocale } from '../../contexts/locale.context';
import ActiveOrders from './ActiveOrders';
import PaidOrders from './PaidOrders';

const OrderArchive = () => {
  const { lang } = useLocale();
  const [tab, setTab] = useState<'active' | 'paid'>('active');

  return (
    <Box sx={{ maxWidth: 800, m: '0 auto', pb: 2 }}>
      <Tabs
        value={tab}
        onChange={(e, v) => setTab(v)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{ mb: 3 }}
      >
        <Tab label={t.open_orders[lang]} value="active" />
        <Tab label={t.closed_orders[lang]} value="paid" />
      </Tabs>

      {tab === 'active' && <ActiveOrders />}
      {tab === 'paid' && <PaidOrders />}
    </Box>
  );
};

export default OrderArchive;
